import { Culture } from '../../types';

export const choctaw: Culture = {
  name: 'Choctaw',
  languageFamily: 'Muskogean',
  terms: [
    {
      word: 'Halito',
      phonetic: 'hah-lih-toh',
      description: 'Choctaw greeting meaning "hello."'
    },
    {
      word: 'Issuba',
      phonetic: 'is-soo-bah',
      description: 'Choctaw word meaning "horse."'
    },
    {
      word: 'Nanih Waiya',
      phonetic: 'nah-nih wah-yah',
      description: 'Sacred mound in Choctaw tradition, considered the origin of the Choctaw people.'
    },
    {
      word: 'Oklahoma',
      phonetic: 'oh-klah-hoh-mah',
      description: 'Derived from the Choctaw words "okla" (people) and "humma" (red), meaning "red people."'
    },
    {
      word: 'Yakoke',
      phonetic: 'yah-koh-keh',
      description: 'Choctaw word for "thank you."'
    }
  ]
};